<section class="vc_row pt-md-6 pt-sm-2 pb-md-6" *ngIf="isReady()">
  <div class="titlebar titlebar-sm scheme-dark text-center">
    <div class="titlebar-inner">
      <div class="container titlebar-container">
        <div class="row titlebar-container">
          <div class="titlebar-col col-md-12">
            <h1 style="font-size: 50px;" appTranslate="pageTitle"></h1>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row" *ngIf="!currentStep.isHidden">
      <div class="lqd-column col-md-12">
        <app-steps-segment *ngIf="hasSteps()" [steps]="steps"></app-steps-segment>
      </div>
    </div>
    <div class="row">
      <div class="lqd-column col-md-12">
        <router-outlet></router-outlet>
        <app-footer *ngIf="!currentStep.isHidden"></app-footer>
      </div>
    </div>
  </div>
</section>
